import styled from '@emotion/styled'
import tw from 'twin.macro'

export const BlogList = styled.ul`
  ${tw`
    w-full
    space-y-20
    md:space-y-24
  `}
`
